import { Cooperation } from "../gardener/gardener.model";

export const determineLevelText = (cooperationLevel: Cooperation["level"]) => {
    switch ( cooperationLevel ) {
        case "bronze": return "Bronze";
        case "silver": return "Sølv";
        case "gold": return "Guld";
        case "platin": return "Platin";
    }
};

export const determineNumberOfTasksBenefit = (cooperationLevel: Cooperation["level"]) => {
    switch ( cooperationLevel ) {
        case "bronze": return "Du kan have op til 3 opgaver i gang på samme tid";
        case "silver": return "Du kan have op til 6 opgaver i gang på samme tid";
        case "gold": return "Du kan have op til  9 opgaver i gang på samme tid";
        case "platin": return "Du kan have over 10 opgaver i gang på samme tid";
    }
};

export const determinePriorityBenefit = (cooperationLevel: Cooperation["level"]) => {
    switch ( cooperationLevel ) {
        case "bronze": return "Du får ikke ekstra prioritet over andre havemænd";
        case "silver": return "Du får prioritet over bronze-havemænd";
        case "gold": return "Du får prioritet over sølv-havemænd";
        case "platin": return "Du får prioritet over guld-havemænd";
    }
}

export const determineNextCooperationLevel = (cooperationLevel: Exclude<Cooperation["level"], "platin">): Exclude<Cooperation["level"], "bronze"> => {
    switch ( cooperationLevel ) {
        case "bronze": return "silver";
        case "silver": return "gold";
        case "gold": return "platin";
    }
};
